export default [
  {
    path: '',
    name: 'requisitions-new',
    component: () => import('pages/requisitions/new/index.vue'),
    meta: { step: 1 },
  },
  {
    path: 'delivery',
    name: 'requisitions-new-delivery',
    component: () => import('pages/requisitions/new/delivery.vue'),
    meta: { step: 2 },
  },
  {
    path: 'approval',
    name: 'requisitions-new-approval',
    component: () => import('pages/requisitions/new/approval.vue'),
    meta: { step: 3 },
  },
  {
    path: 'review',
    name: 'requisitions-new-review',
    component: () => import('pages/requisitions/new/review.vue'),
    meta: { step: 4 },
  },
]
